import { Grid, TextField } from "@mui/material";
import { useContext, useState } from "react";

import Context from "../../context";

// ----------------------------------------------------------------------

export const ListInputs = () => {
	const [focus, setFocus] = useState(0);
	const { actions, state } = useContext(Context);

	const onChange = (value: any, index: number) => {
		let newValues = [...state.code];
		if (value === "") newValues[index] = null;
		else if (typeof value === "string") newValues[index] = parseInt(value.slice(0, 1));
		setFocus(index + 1);
		actions.onChangeCode([...newValues]);
	};

	const handlePaste = (event: any) => {
		const pastedText: string = event.clipboardData.getData("Text");
		if (pastedText.length === 6 && !isNaN(parseInt(pastedText)))
			actions.onChangeCode(pastedText.split("").map((n) => parseInt(n)));
	};

	return (
		<Grid container gap={2}>
			{[...Array(6)].map((_i, index) => (
				<Grid item key={index}>
					<TextField
						value={state.code[index]}
						placeholder='0'
						onChange={(e) => onChange(e.target.value, index)}
						sx={{ width: 55 }}
						type='number'
						onPaste={handlePaste}
						onFocus={() => setFocus(index)}
						focused={focus === index}
						inputProps={{ style: { textAlign: "center" }, maxLength: 1 }}
						inputRef={(input) => {
							if (focus === index && input) {
								input.focus();
							}
						}}
					/>
				</Grid>
			))}
		</Grid>
	);
};

export default ListInputs;
